module.exports = __webpack_public_path__ + "static/media/01.National Award-Devanna Kamath.cb04a41a.JPG";